export { default } from './ArtistAddNewRecordingParticipant';
